// @flow
/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';

type Props = {
  /** CSS selector to skip to somewhere on the page **/
  skipToSelector: string,
  /** Label for a11y **/
  ariaLabel: string,
  /** Location of the website url */
  urlPath?: string,
};

const linkCss = {
  color: Colors.transparent,
  padding: '0px 20px',
  width: '1px',
  height: '1px',
  fontSize: '0',
  '&:focus': {
    width: 'auto',
    height: 'auto',
    fontSize: '16px',
    color: Colors.captainAmerica,
  },
};

const renderSkipLink = (skipToSelector, urlPath) => {
  if (urlPath) {
    return `${urlPath}#${skipToSelector}`;
  } else {
    return `#${skipToSelector}`;
  }
};

const SkipNav = ({
  ariaLabel = 'Skip Navigation',
  skipToSelector = '#main',
  urlPath,
}: Props) => {
  return (
    <a
      aria-label={ariaLabel}
      css={linkCss}
      href={renderSkipLink(skipToSelector, urlPath)}
    >
      Skip Navigation
    </a>
  );
};

export default SkipNav;
